var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 55,
    viewBox: "0 0 183 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.046 54.1514H7.29639C3.58389 54.1514 0.546387 51.1139 0.546387 47.4014V6.90137C0.546387 3.18887 3.58389 0.151367 7.29639 0.151367H176.046C179.759 0.151367 182.796 3.18887 182.796 6.90137V47.4014C182.796 51.1139 179.759 54.1514 176.046 54.1514Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M176.046 1.23137C179.178 1.23137 181.716 3.76937 181.716 6.90137V47.4014C181.716 50.5334 179.178 53.0714 176.046 53.0714H7.29639C4.16439 53.0714 1.62639 50.5334 1.62639 47.4014V6.90137C1.62639 3.76937 4.16439 1.23137 7.29639 1.23137H176.046ZM176.046 0.151367H7.29639C3.58389 0.151367 0.546387 3.18887 0.546387 6.90137V47.4014C0.546387 51.1139 3.58389 54.1514 7.29639 54.1514H176.046C179.759 54.1514 182.796 51.1139 182.796 47.4014V6.90137C182.796 3.18887 179.759 0.151367 176.046 0.151367Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5636 13.9758C64.5636 15.1098 64.2261 16.0143 63.5511 16.6758C62.7951 17.4723 61.7961 17.8773 60.5811 17.8773C59.4066 17.8773 58.4211 17.4723 57.5976 16.6623C56.7741 15.8523 56.3691 14.8398 56.3691 13.6518C56.3691 12.4503 56.7741 11.4513 57.5976 10.6413C58.4211 9.83127 59.4066 9.42627 60.5811 9.42627C61.1616 9.42627 61.7151 9.53427 62.2416 9.76377C62.7681 9.99327 63.1866 10.2903 63.5106 10.6683L62.7951 11.3838C62.2551 10.7493 61.5261 10.4253 60.5811 10.4253C59.7306 10.4253 58.9881 10.7223 58.3671 11.3298C57.7461 11.9238 57.4356 12.7068 57.4356 13.6653C57.4356 14.6238 57.7461 15.4068 58.3671 16.0008C58.9881 16.5948 59.7306 16.9053 60.5811 16.9053C61.4856 16.9053 62.2416 16.6083 62.8491 16.0008C63.2406 15.6093 63.4701 15.0558 63.5241 14.3538H60.5811V13.3683H64.5096C64.5366 13.5843 64.5636 13.7868 64.5636 13.9758Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.27,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7875 10.6006H67.102V13.1656H70.423V14.1376H67.102V16.7026H70.7875V17.7016H66.0625V9.60156H70.7875V10.6006Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.27,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1747 17.7016H74.1352V10.6006H71.8672V9.60156H77.4292V10.6006H75.1612V17.7016H75.1747Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.27,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4653 17.7016V9.60156H82.5048V17.7016H81.4653Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.27,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1219 17.7016H86.0825V10.6006H83.8145V9.60156H89.3765V10.6006H87.1085V17.7016H87.1219Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.27,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M99.92 16.6488C99.1235 17.4723 98.138 17.8773 96.95 17.8773C95.762 17.8773 94.7765 17.4723 93.98 16.6488C93.1835 15.8253 92.792 14.8263 92.792 13.6518C92.792 12.4773 93.1835 11.4648 93.98 10.6548C94.7765 9.83127 95.762 9.42627 96.95 9.42627C98.1245 9.42627 99.11 9.83127 99.92 10.6548C100.716 11.4783 101.121 12.4773 101.121 13.6518C101.108 14.8398 100.716 15.8388 99.92 16.6488ZM94.7495 15.9738C95.3435 16.5813 96.086 16.8783 96.95 16.8783C97.814 16.8783 98.5565 16.5813 99.1505 15.9738C99.7445 15.3663 100.055 14.5968 100.055 13.6518C100.055 12.7068 99.758 11.9373 99.1505 11.3298C98.5565 10.7223 97.814 10.4118 96.95 10.4118C96.086 10.4118 95.3435 10.7088 94.7495 11.3163C94.1555 11.9373 93.845 12.7068 93.845 13.6518C93.845 14.5968 94.1555 15.3663 94.7495 15.9738Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.27,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.58 17.7016V9.60156H103.849L107.791 15.9061H107.831L107.791 14.3401V9.60156H108.83V17.7016H107.75L103.633 11.1001H103.592L103.633 12.6661V17.7016H102.58Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.27,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5352 29.5135C89.3627 29.5135 86.7707 31.93 86.7707 35.251C86.7707 38.5585 89.3627 40.9885 92.5352 40.9885C95.7077 40.9885 98.2997 38.5585 98.2997 35.251C98.2997 31.93 95.7077 29.5135 92.5352 29.5135ZM92.5352 38.734C90.7937 38.734 89.2952 37.303 89.2952 35.251C89.2952 33.1855 90.7937 31.768 92.5352 31.768C94.2767 31.768 95.7752 33.1855 95.7752 35.251C95.7752 37.303 94.2632 38.734 92.5352 38.734ZM79.9532 29.5135C76.7807 29.5135 74.1887 31.93 74.1887 35.251C74.1887 38.5585 76.7807 40.9885 79.9532 40.9885C83.1257 40.9885 85.7177 38.5585 85.7177 35.251C85.7177 31.93 83.1257 29.5135 79.9532 29.5135ZM79.9532 38.734C78.2117 38.734 76.7132 37.303 76.7132 35.251C76.7132 33.1855 78.2117 31.768 79.9532 31.768C81.6947 31.768 83.1932 33.1855 83.1932 35.251C83.1932 37.303 81.6947 38.734 79.9532 38.734ZM64.9952 31.282V33.712H70.8272C70.6517 35.0755 70.1927 36.088 69.5042 36.7765C68.6537 37.627 67.3307 38.5585 65.0087 38.5585C61.4177 38.5585 58.6097 35.6695 58.6097 32.0785C58.6097 28.4875 61.4177 25.5985 65.0087 25.5985C66.9392 25.5985 68.3567 26.3545 69.3962 27.34L71.1107 25.6255C69.6527 24.235 67.7222 23.1685 64.9952 23.1685C60.0812 23.1685 55.9502 27.1645 55.9502 32.092C55.9502 37.006 60.0812 41.0155 64.9952 41.0155C67.6547 41.0155 69.6527 40.1515 71.2187 38.518C72.8252 36.9115 73.3247 34.6435 73.3247 32.821C73.3247 32.254 73.2842 31.7275 73.1897 31.2955H64.9952V31.282ZM126.164 33.172C125.691 31.8895 124.233 29.5135 121.25 29.5135C118.293 29.5135 115.836 31.8355 115.836 35.251C115.836 38.464 118.266 40.9885 121.533 40.9885C124.166 40.9885 125.691 39.382 126.312 38.4505L124.355 37.141C123.707 38.0995 122.816 38.734 121.533 38.734C120.251 38.734 119.333 38.14 118.752 36.9925L126.434 33.82L126.164 33.172ZM118.334 35.089C118.266 32.875 120.048 31.741 121.331 31.741C122.33 31.741 123.18 32.2405 123.464 32.956L118.334 35.089ZM112.097 40.651H114.621V23.776H112.097V40.651ZM107.966 30.796H107.871C107.304 30.121 106.224 29.5135 104.847 29.5135C101.972 29.5135 99.3392 32.038 99.3392 35.278C99.3392 38.491 101.972 41.002 104.847 41.002C106.211 41.002 107.304 40.3945 107.871 39.6925H107.952V40.516C107.952 42.7165 106.778 43.891 104.888 43.891C103.349 43.891 102.39 42.784 101.999 41.8525L99.7982 42.7705C100.433 44.296 102.107 46.159 104.888 46.159C107.844 46.159 110.342 44.4175 110.342 40.1785V29.8645H107.952V30.796H107.966ZM105.063 38.734C103.322 38.734 101.864 37.276 101.864 35.278C101.864 33.253 103.322 31.7815 105.063 31.7815C106.778 31.7815 108.128 33.2665 108.128 35.278C108.141 37.276 106.791 38.734 105.063 38.734ZM137.99 23.776H131.955V40.651H134.48V34.252H138.003C140.798 34.252 143.538 32.227 143.538 29.014C143.538 25.801 140.771 23.776 137.99 23.776ZM138.044 31.903H134.466V26.1115H138.044C139.934 26.1115 141 27.6775 141 29.0005C141 30.3235 139.934 31.903 138.044 31.903ZM153.623 29.4865C151.8 29.4865 149.91 30.2965 149.127 32.065L151.368 32.9965C151.841 32.065 152.732 31.7545 153.663 31.7545C154.973 31.7545 156.296 32.5375 156.309 33.928V34.1035C155.85 33.847 154.878 33.4555 153.677 33.4555C151.26 33.4555 148.817 34.7785 148.817 37.249C148.817 39.5035 150.788 40.9615 153.002 40.9615C154.689 40.9615 155.634 40.2055 156.215 39.3145H156.296V40.624H158.726V34.1575C158.739 31.1605 156.498 29.4865 153.623 29.4865ZM153.312 38.734C152.489 38.734 151.341 38.3155 151.341 37.303C151.341 36.007 152.772 35.5075 154.014 35.5075C155.121 35.5075 155.648 35.7505 156.309 36.0745C156.12 37.627 154.77 38.734 153.312 38.734ZM167.595 29.851L164.706 37.168H164.625L161.628 29.851H158.915L163.41 40.084L160.845 45.7675H163.478L170.403 29.851H167.595ZM144.915 40.651H147.44V23.776H144.915V40.651Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6405 10.3308C14.249 10.7493 14.0195 11.3973 14.0195 12.2208V42.0828C14.0195 42.9198 14.249 43.5678 14.6405 43.9728L14.735 44.0673L31.4615 27.3543V27.1518V26.9493L14.735 10.2363L14.6405 10.3308Z",
    fill: "url(#paint0_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0374 32.93L31.4619 27.3545V27.152V26.9495L37.0374 21.374L37.1589 21.4415L43.7604 25.1945C45.6504 26.261 45.6504 28.016 43.7604 29.096L37.1589 32.849L37.0374 32.93Z",
    fill: "url(#paint1_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1591 32.8614L31.4621 27.1509L14.6411 43.9719C15.2621 44.6334 16.2881 44.7144 17.4491 44.0529L37.1591 32.8614Z",
    fill: "url(#paint2_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1585 21.4545L17.435 10.2495C16.274 9.58797 15.248 9.66897 14.627 10.3305L31.4615 27.1515L37.1585 21.4545Z",
    fill: "url(#paint3_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M37.0366 32.728L17.4346 43.8655C16.3411 44.4865 15.3556 44.446 14.7346 43.879L14.6401 43.9735L14.7346 44.068C15.3691 44.635 16.3411 44.6755 17.4346 44.0545L37.1581 32.8495L37.0366 32.728Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M14.64 43.7845C14.2485 43.366 14.019 42.718 14.019 41.8945V42.097C14.019 42.934 14.2485 43.582 14.64 43.987L14.7345 43.8925L14.64 43.7845Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M43.7599 28.9059L37.0234 32.7264L37.1449 32.8479L43.7464 29.0949C44.6914 28.5549 45.1639 27.8529 45.1639 27.1509C45.0964 27.7854 44.6239 28.4199 43.7599 28.9059Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M17.4353 10.4386L43.7603 25.3966C44.6108 25.8826 45.0968 26.5036 45.1778 27.1516C45.1778 26.4496 44.7053 25.7341 43.7603 25.2076L17.4353 10.2496C15.5453 9.18315 14.0063 10.0741 14.0063 12.2341V12.4366C14.0063 10.2631 15.5588 9.37215 17.4353 10.4386Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 29.976,
    y1: 11.9101,
    x2: 7.31975,
    y2: 34.5663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 46.2232,
    y1: 27.154,
    x2: 13.5574,
    y2: 27.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 34.0634,
    y1: 30.2507,
    x2: 3.33972,
    y2: 60.9745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 10.3977,
    y1: 0.389477,
    x2: 24.1172,
    y2: 14.1089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/play_store.93aac613.svg";
export { ForwardRef as ReactComponent };